export default __webpack_public_path__ + "static/media/blackLotusLogo2.8323a5fc.png";